export const LOGOUT = 'Logout';
export const LOGIN = 'Login';
export const LOGIN_AS_ADMIN = 'Log in as admin';

export const ENTER_EMAIL = 'Enter email';
export const ENTER_PASSWORD = 'Enter password';
export const ENTER_NAME = 'Enter name';
export const ENTER_LIST_ID = 'Enter list id';

export const AUTO_PLAN_FEEDBACK = 'Auto-plan feedback';
export const DATES_PLANNED = 'Dates planned';
export const FEEDBACK = 'Feedback';

export const SEARCH_BY_EMAIL = 'Search by email';
export const SEARCH_BY_NAME = 'Search by name';
export const SELECT = 'Select';

export const ID = 'Id';
export const NAME = 'Name';
export const FIRST_NAME = 'Name';
export const EMAIL = 'Email';
export const EMAIL_TYPE = 'Email type';
export const EMAIL_VERIFIED = 'Email verified?';
export const FULL_ACCESS = 'Full access?';
export const DELETED = 'Deleted';
export const ROLE = 'Role';
export const MEMBERSHIP_TYPE = 'Membership';
export const SUBSCRIPTION = 'Subscription';
export const OF = 'of';
export const USERS = 'Users';
export const SUBSCRIBED_USERS = 'Subscribed users';
export const INVITED_AND_OLD_USERS = 'Invited and old users';
export const ITEMS = 'items';
export const PASSWORD = 'Password';
export const CANCELED = 'Canceled';

export const ENV = 'Environment';
export const TRIAL = 'Trial';
export const STATUS = 'Status';

export const INVITE_USER = 'Invite user';

export const REQUIRED = 'Required';

export const ORGANIZATION = 'Organization';
export const ORGANIZATIONS = 'Organizations';
export const COACHES = 'Coaches';
export const CANCELLATIONS = 'Cancellations';
export const ANALYTICS = 'Analytics';
export const RESET_TRIALS = 'Reset trials';
export const FIRST_WEEK = 'First week';
export const USAGE = 'Usage';
export const CREATED_AT = 'Created';
export const ACCESS_UNTIL = 'Access until';
export const ACCESS = 'Access';
export const SENDY_LIST_ID = 'Sendy list id';
export const REGISTRATION_LINK = 'Registration Link';
export const EMAIL_DOMAIN = 'Email domain';
export const LOGO = 'Logo';
export const LOGO_URL = 'Logo url';
export const CREATE_ORGANIZATION = 'Create Organization';
export const UNREDEEMED_USERS = 'Unredeemed users';
export const SCHEDULED_EMAILS = 'Scheduled emails';
export const SCHEDULED_AT = 'Scheduled at';
export const SYLLABUS_IMPORTS = 'Syllabus imports';
export const AI_USAGE = 'AI Usage';

export const CANCELLATION_REASON_1 = `Don't like Shovel`;
export const CANCELLATION_REASON_2 = `Can't find things`;
export const CANCELLATION_REASON_3 = 'Difficult to learn';
export const CANCELLATION_REASON_4 = 'Too hard to use';
export const CANCELLATION_REASON_5 = 'Too slow to load';
export const CANCELLATION_REASON_6 = 'Missing feature';
export const CANCELLATION_REASON_7 = 'Too expensive';
export const CANCELLATION_REASON_8 = 'Other';
